import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Transfers from "@/pages/Transfers";
import TransferDetail from "@/pages/TransferDetail";
import Alloggi from "@/pages/Alloggi";
import Experiences from "@/pages/Experiences";
import PackageDetail from "@/pages/PackageDetail";
import BookingStatus from "@/pages/BookingStatus";
import BuilderHome from "@/pages/builder/BuilderHome";
import RomeBuilder from "@/pages/builder/RomeBuilder";
import ItalyBuilder from "@/pages/builder/ItalyBuilder";
import Itineraries from "@/pages/Itineraries";
import TailorMade from "@/pages/TailorMade";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Concierge from "@/pages/Concierge";
import { ConciergeFab } from "@/components/ConciergeFab";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import NotFound from "@/pages/NotFound";
import GestionaleLink from "@/pages/GestionaleLink";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
};

const AdminArea = () => <GestionaleLink />;

const PublicLayout = ({ children }) => (
    <>
        <Navbar />
        <main>{children}</main>
        <ConciergeFab />
        <Footer />
    </>
);

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let id;
        const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
        id = requestAnimationFrame(raf);
        return () => { cancelAnimationFrame(id); lenis.destroy(); };
    }, []);

    return (
        <HelmetProvider>
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                        <Route path="/transfer" element={<PublicLayout><Transfers /></PublicLayout>} />
                        <Route path="/transfer/:id" element={<PublicLayout><TransferDetail /></PublicLayout>} />
                        <Route path="/alloggi" element={<PublicLayout><Alloggi /></PublicLayout>} />
                        <Route path="/esperienze" element={<PublicLayout><Experiences /></PublicLayout>} />
                        <Route path="/pacchetto/:id" element={<PublicLayout><PackageDetail /></PublicLayout>} />
                        <Route path="/stato-prenotazione" element={<PublicLayout><BookingStatus /></PublicLayout>} />
                        <Route path="/itinerari" element={<PublicLayout><Itineraries /></PublicLayout>} />
                        <Route path="/itinerario" element={<PublicLayout><BuilderHome /></PublicLayout>} />
                        <Route path="/itinerario/roma" element={<PublicLayout><RomeBuilder /></PublicLayout>} />
                        <Route path="/itinerario/italia" element={<PublicLayout><ItalyBuilder /></PublicLayout>} />
                        <Route path="/su-misura" element={<PublicLayout><TailorMade /></PublicLayout>} />
                        <Route path="/contatti" element={<PublicLayout><Contact /></PublicLayout>} />
                        <Route path="/chi-siamo" element={<PublicLayout><About /></PublicLayout>} />
                        <Route path="/concierge" element={<PublicLayout><Concierge /></PublicLayout>} />
                        <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
                        <Route path="/payment/cancel" element={<PublicLayout><PaymentCancel /></PublicLayout>} />
                        <Route path="/admin" element={<AdminArea />} />
                        <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
                    </Routes>
                    <Toaster theme="dark" position="bottom-right" />
                </BrowserRouter>
            </LanguageProvider>
        </HelmetProvider>
    );
}

export default App;
